import React from "react";

function VisitUs() {
    return (
        <iframe
            id="visit-us"
            title="osso-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2875.761981813491!2d-78.85005888449489!3d43.881482879114!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d51d2fe0c5d2d1%3A0x19688693ec78b9df!2sOsso%20City%20Lighting%20Limited!5e0!3m2!1sen!2sca!4v1576166279902!5m2!1sen!2sca"
            frameBorder="0"
            style={{ border: 0 }}
        ></iframe>
    );
}

export default VisitUs;
